<mat-horizontal-stepper [linear]="true" #registroClienteStepper>
  <mat-step [stepControl]="clienteFormGroup">
    <h3>{{subtitulo}}</h3>
    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" descricao="{{'cpf_cnpj' | transloco}}" autoPreenchimento="off"
          nomeControle="cpf_cnpj" mascara="000.000.000-00||00.000.000/0000-00" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup"
          [descricao]="tipoPessoa === 'F' ? ('nome' | transloco) : 'Razão social'" autoPreenchimento="off"
          nomeControle="nome" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row" *ngIf="tipoPessoa === 'J'">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" descricao="Nome do contato principal" autoPreenchimento="off"
          nomeControle="nome_contato" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup"
          [descricao]="tipoPessoa === 'F' ? ('celular' | transloco) : 'Celular do contato principal'"
          autoPreenchimento="off" nomeControle="telefone" mascara="(00) 00000-0000" classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup"
          [descricao]="tipoPessoa === 'F' ? ('email' | transloco) : 'Email do contato principal'"
          autoPreenchimento="off" nomeControle="email" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <span *ngIf="tipoPessoa === 'J'">
      <div class="row">
        <div class="col-xl-6">
          <app-campo [formulario]="clienteFormGroup" descricao="Inscrição municipal" autoPreenchimento="off"
            nomeControle="inscricao_municipal" classe="horizontal-100"></app-campo>
        </div>

        <div class="col-xl-6">
          <app-campo [formulario]="clienteFormGroup" descricao="Inscrição estadual" autoPreenchimento="off"
            nomeControle="inscricao_estadual" classe="horizontal-100"></app-campo>
        </div>
      </div>
    </span>

    <div class="row" *ngIf="tipoPessoa === 'F'">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" descricao="{{'documento_rg_cnh_rne' | transloco}}"
          autoPreenchimento="off" nomeControle="documento" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-opcoes [formulario]="clienteFormGroup" nomeControle="tipo_documento"
          identificacao="{{'tipo_documento' | transloco}}" [requerido]="true" [danger]="danger"
          [opcoes]="tiposDocumento"
          [textoAjuda]="!clienteFormGroup.controls['tipo_documento']?.value ? ('escolha_tipo_documento' | transloco) : ''"></app-opcoes>
      </div>
    </div>

    <div class="row" *ngIf="tipoPessoa === 'F'">
      <div class="col-xl-6">
        <app-opcoes [formulario]="clienteFormGroup" nomeControle="genero"
          identificacao="{{'genero' | transloco}}" [requerido]="true" [danger]="danger"
          [opcoes]="generos"
          [textoAjuda]="!clienteFormGroup.controls['genero']?.value ? ('escolha_genero' | transloco) : ''"></app-opcoes>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" tipo="password" descricao="{{'senha_acesso' | transloco}}"
          autoPreenchimento="off" nomeControle="senha" classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" tipo="password" descricao="{{'confirmacao_senha' | transloco}}"
          autoPreenchimento="off" nomeControle="confirmacao_senha" classe="horizontal-100"
          textoAjuda="{{'senhas_nao_coincidem' | transloco}}"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 order-xl-last">
        <app-botao texto="Próximo" [desabilitado]="loading" classe="btn-primary horizontal-100" posicaoDoIcone="direita"
          (clique)="proximo()">
        </app-botao>
      </div>
      <div class="col-xl-6">
        <app-botao texto="{{'ja_tenho_conta' | transloco}}" [desabilitado]="loading" tamanhoDoTexto="0.8rem"
          classe="btn-primary text-uppercase order-sm-last horizontal-100" (clique)="login()">
        </app-botao>
      </div>
    </div>
  </mat-step>

  <mat-step [stepControl]="enderecoFormGroup">
    <h3>Me informa o endereço para podermos achar os produtos mais perto de você.</h3>
    <div class="row">
      <div class="col-xl-4">
        <app-campo [formulario]="enderecoFormGroup" descricao="CEP" autoPreenchimento="off" nomeControle="cep"
          mascara="00000-000" classe="horizontal-100" (alteracao)="buscaCep()" [botaoAcao]="true"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="Logradouro" autoPreenchimento="off"
          nomeControle="logradouro" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-2">
        <app-campo [formulario]="enderecoFormGroup" descricao="Número" autoPreenchimento="off" nomeControle="numero"
          classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="Complemento" autoPreenchimento="off"
          nomeControle="complemento" classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="Bairro" autoPreenchimento="off" nomeControle="bairro"
          classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="Cidade" autoPreenchimento="off" nomeControle="cidade"
          classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-3">
        <app-campo [formulario]="enderecoFormGroup" descricao="Estado" autoPreenchimento="off" nomeControle="estado"
          classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-3">
        <app-campo [formulario]="enderecoFormGroup" descricao="País" autoPreenchimento="off" nomeControle="pais"
          classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 order-xl-last">
        <app-botao texto="Concluir" [executando]="loading" classe="btn-primary horizontal-100" (clique)="registro()">
        </app-botao>
      </div>
      <div class="col-xl-6">
        <app-botao texto="{{'voltar' | transloco}}" posicaoDoIcone="esquerda" [desabilitado]="loading"
          classe="btn-link text-uppercase horizontal-100" (clique)="anterior()">
        </app-botao>
      </div>
    </div>
  </mat-step>

  <mat-step [stepControl]="confirmacaoFormGroup">
    <h3>Ótimo, falta bem pouquinho.</h3>
    <h4>Enviamos um código por SMS para o telefone <strong>{{clienteFormGroup.controls['telefone'].value}}</strong></h4>
    <div class="row">
      <div class="col-xl-12">
        <app-campo [formulario]="confirmacaoFormGroup" descricao="Código de confirmação" autoPreenchimento="off"
          nomeControle="codigo" classe="horizontal-100"></app-campo>

        <app-botao texto="{{'voltar' | transloco}}" posicaoDoIcone="esquerda" [desabilitado]="loading"
          classe="btn-link text-uppercase horizontal-100" (clique)="anterior()">
        </app-botao>

        <app-botao texto="Verificar código" [executando]="loading" classe="btn-primary horizontal-100"
          (clique)="verificarCodigoSMS()">
        </app-botao>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
<div id="recaptcha-container"></div>